import Axios from 'axios';
import { AdminPath } from './AdminPath';

export class MediaGridVersioning {
    constructor() {
        const adminPath = new AdminPath();

        document.querySelectorAll('.version').forEach(select => {
            select.onchange = event => {
                Axios.post('/' + adminPath.url('admin/mediagrid/version'), {
                    language_id: event.target.attributes['language-id'].nodeValue,
                    mediagrid_id: event.target.attributes['mediagrid-id'].nodeValue,
                    linked_mediagrid_id: event.target.value
                });
            }
        });
    }
}
